<template>
    <dash
        icon="fa fa-comments"
        titulo="CONTRATAÇÕES SEM AVALIAÇÃO"
        :qtd="qtd"
        :loading="loading"
        color="#A3E0FC"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent2'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
